// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/Customer.css
// module id = 385
// module chunks = 0